"use strict";
var isIos = require("./is-ios");
var webkitRegexp = /webkit/i;
function isWebkit(ua) {
    return webkitRegexp.test(ua);
}
module.exports = function isIosSafari(ua) {
    ua = ua || window.navigator.userAgent;
    return isIos(ua) && isWebkit(ua) && ua.indexOf("CriOS") === -1;
};
